<template>
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 class="mb-sm-0">Daftar Klasifikasi</h4>

            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <Link href="/admin/indagklasifikasi">Daftar Klasifikasi</Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <div>
                  <h4 class="card-title">Manajemen Daftar Klasifikasi</h4>
                  <p class="card-title-desc mb-0">Pengelompokan Jenis/Klasifikasi IKM.</p>
                </div>
                <div>
                  <button type="button" class="btn btn-success" @click="tambah">Tambah Baru</button>
                </div>
              </div>

              <hr>

              <data-attribut :data="indagklasifikasi">
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead>
                    <tr>
                      <th class="text-center">No</th>
                      <th>Kode</th>
                      <th>Urai Klasifikasi</th>
                      <th class="text-center">Jumlah Unit Usaha</th>
                      <th class="text-center">Jumlah Tenaga Kerja</th>
                      <th class="text-center">Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in indagklasifikasi.data" :key="index">
                      <td scope="row" class="text-center">{{ indagklasifikasi.from + index }}</td>
                      <td scope="row" v-text="row.kodeklasifikasi"></td>
                      <td scope="row" v-text="row.uraiklasifikasi"></td>
                      <td scope="row" class="text-center" v-text="row.jumlah_unit_usaha"></td>
                      <td scope="row" class="text-center" v-text="row.jumlah_tenagakerja"></td>
                      <td scope="row" class="text-center">
                        <a @click="edit(row)" class="p-0 btn btn-sm btn-link">Edit</a> | 
                        <a @click="remove(row)" class="p-0 btn btn-sm btn-link">Hapus</a>
                      </td>
                    </tr>
                    <tr v-if="indagklasifikasi.data.length == 0">
                      <td scope="row" colspan="6" class="text-center">
                        <i>Tidak ditemukan data!</i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </data-attribut>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->
    </div>
    <!-- container-fluid -->
  </div>

  <modal :show="form.show" @close="form.show = false" :title="(form.id ? 'Ubah': 'Tambah') + ' Klasifikasi'" backdrop="static" size="xl">
    <form @submit.prevent="action">

      <div class="d-flex">
        <div class="p-3 pt-0 flex-fill">
          <div class="mb-2 row">
            <label for="kodeklasifikasi" class="col-sm-2 col-form-label">Kode Klasifikasi</label>
            <div class="col-sm-10">
              <input type="numberic" :readonly="form.readonly"
                :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }"
                id="kodeklasifikasi" v-model="form.data.kodeklasifikasi">
            </div>
          </div>

          <div class="mb-2 row">
            <label for="uraiklasifikasi" class="col-sm-2 col-form-label">Urai Klasifikasi</label>
            <div class="col-sm-10">
              <input type="text" :readonly="form.readonly"
                :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }" id="uraiklasifikasi"
                v-model="form.data.uraiklasifikasi">
            </div>
          </div>
        </div>

        <div>
            <div class="d-grid gap-2 flex-row">
              <button type="button" v-if="form.readonly && form.id" @click="form.readonly = false"
                class="btn btn-outline-success">Ubah</button>
              <button type="submit" v-if="!form.readonly" class="btn btn-success">Simpan</button>
              <button type="button" v-if="!form.readonly && form.id" @click="form.readonly = true"
                class="btn btn-danger">Batal</button>
            </div>
          </div>
      </div>

    </form>
  </modal>
</template>

<script>
import Layout from '@/layout/Index'
import Modal from '@/components/Modal'
import DataAttribut from '@/components/DataAttribut'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'

export default {
  layout: Layout,
  components: { Modal, DataAttribut },
  props: {
    indagklasifikasi: Object
  },
  data() {
    return {
      form: {
        show: false,
        id: null,
        readonly: false,
        data: {}
      },
    }
  },
  methods: {
    tambah() {
      this.form.id = null;
      this.form.show = true;
      this.form.readonly = false;
      this.form.data = {};
    },
    edit({ id, kodeklasifikasi, uraiklasifikasi }) {
      this.form.id = id;
      this.form.show = true;
      this.form.readonly = true;
      this.form.data = {
        kodeklasifikasi,
        uraiklasifikasi
      }
    },
    action() {
      const onSuccess = () => {
        this.form.show = false;
        this.form.id = null;
        this.form.data = {};
      };
      if(this.form.id) {
        this.$inertia.put('/admin/indagklasifikasi/' + this.form.id, this.form.data, { onSuccess });
      } else {
        this.$inertia.post('/admin/indagklasifikasi', this.form.data, { onSuccess });
      }
    },
    remove(row) {
      if(confirm('Konfirmasi Proses Penghapusan?'))
      this.$inertia.delete('/admin/indagklasifikasi/' + row.id);
    }
  },
}
</script>
